export const getCurrencySymbol = (currency: string) => {
  switch (currency) {
    case "eur":
      return "€";
    case "usd":
      return "$";
    case "chf":
      return "CHF";
    default:
      return "RON";
  }
};
